export default process.env.GATEWAY_SERVER as string;
